<!-- TexteAssociation.vue -->
<template>
  <TexteBloc>
    <p>
      En tant que président de l’association Alpes Esport, 
      je suis responsable de la vision stratégique et du bon fonctionnement global de la structure. 
      Je m’implique activement dans la définition des objectifs à moyen et long terme de l’association, 
      en veillant à ce qu’ils soient alignés avec les attentes de notre communauté et les évolutions du secteur de l’esport. 
      Mon rôle inclut également une forte dimension de gestion de projet : 
      je coordonne l’organisation de nos événements de leur conception à leur réalisation
      en m’assurant du respect des délais, des budgets et des standards de qualité que nous nous fixons.
      <br /><br />
      Je travaille avec une équipe d'une dizaine de bénévoles et collaborateurs, 
      répartis sur des pôles variés (communication, tournois, technique, streaming...), 
      et veille à favoriser un management humain et collaboratif. 
      J’assure également le lien avec les partenaires, les collectivités locales et les acteurs institutionnels, 
      dans une démarche de professionnalisation progressive du milieu associatif esportif. À travers Alpes Esport, 
      mon objectif est de créer un cadre structuré, inclusif et ambitieux pour le développement de l’esport 
      dans notre région et au-delà.
    </p>
  </TexteBloc>
</template>

<script>
export default {
  name: 'AssociationText'
};
</script>

<style scoped>
</style>